import { FontWeight, Heading, LiliButton, LiliButtonType, Text } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { featureAccess, LimitedFeatureType } from '../../../services/appAccess.service';
import { FeatureAccess } from '../../AccountSettings/components/rolesAndPermissions/PermissionsList';

interface LimitsModalLeftComponentProps {
  handleCloseModal: () => void;
  handleRequestUpgrade: () => void;
  loadingRequestUpgrade: boolean;
}

export const LimitsModalLeftComponent = ({
  handleCloseModal,
  handleRequestUpgrade,
  loadingRequestUpgrade,
}: LimitsModalLeftComponentProps) => {
  const InAppLimitsPermmision = featureAccess(null, LimitedFeatureType.InAppLimits);
  const disabled = InAppLimitsPermmision !== FeatureAccess.READ_WRITE;
  const { t } = useTranslation('limitsEN');
  return (
    <div className='w-[455px] h-full p-[40px] pr-[40px] border-r-[1px] border-r-surface-purple-secondary bg-bw00 rounded-l-[12px]'>
      <div
        id='new-badge'
        className='w-[35px] h-[18px] bg-surface-brand-action-05 rounded-[3px] gap-[10px] py-[10px] px-[5px] justify-center items-center flex'
      >
        <Text.H14 fontWeight={FontWeight.REGULAR} className='text-bw00 text-sm px-[10px]'>
          {t('NEW')}
        </Text.H14>
      </div>

      <Heading.H4 className='mt-[12px]' fontWeight={FontWeight.MEDIUM}>
        {t('LEFT_COMPONENT_HEADER')}
      </Heading.H4>
      <Text.H9 className='mt-[12px] text-text-main-secondary '>
        <span>{t('LEFT_COMPONENT_TEXT1')}</span>
        <span>{t('LEFT_COMPONENT_TEXT2')}</span>
      </Text.H9>
      <div className='mt-[178px] flex'>
        <div className='w-[189px] mr-[12px]'>
          <LiliButton
            id='apply'
            className='w-[189px] text-sm '
            type={LiliButtonType.PRIMARY}
            disabled={disabled}
            isLoading={loadingRequestUpgrade}
            title={t('BUTTON_APPLY')}
            onClick={handleRequestUpgrade}
          />
        </div>

        <LiliButton
          id='not-now'
          className='w-[176px] text-sm'
          type={LiliButtonType.TERTIARY}
          title={t('BUTTON_NOT_NOW')}
          onClick={handleCloseModal}
        />
      </div>
    </div>
  );
};
